// extracted by mini-css-extract-plugin
export default {"CreateArticlePage":"createArticle_CreateArticlePage__tGQ+o","inputWrapper":"createArticle_inputWrapper__fXJWx","buttonWrapper":"createArticle_buttonWrapper__Vi8IR"};